module.exports = __webpack_public_path__ + "static/media/agree.0afda477.png";